module.exports = __webpack_public_path__ + "static/media/hubproof.b2db32fe.png";